/* eslint-disable */
const module = {
    namespaced: true,
    state: {
        feeAgreement: {},
        isEligible: null,
        isLogin: true,
        showFooter: true,
        needHelpButton: {
            isClicked: false,
            isEnabled: true,
            text: 'Need help?'
        },
        continueButton: {
            isClicked: false,
            isEnabled: false,
            text: 'Continue'
        },
    },
    mutations: {
        setContinueButton(state, continueButton){
          state.continueButton = {...state.continueButton, ...continueButton};
        },
        setShowFooter(state, isShow){
          state.showFooter = isShow;
        },
        setNeedHelpButton(state, needHelpButton){
            state.needHelpButton = {...state.needHelpButton, ...needHelpButton};
        },
        updateFeeAgreement(state, feeAgreement) {
            state.feeAgreement = feeAgreement;
        },
        setEligibility(state, isEligible) {
            state.isEligible = isEligible;
        },
        setLoginStatus(state, isLogin) {
            state.isLogin = isLogin
        }
    },
    getters: {
        getCaseManager: state => state.feeAgreement.case_manager,
        getProject: state => state.feeAgreement.project,
        getClient: state => state.feeAgreement.client,
        feeAgreement: state => state.feeAgreement,
        isEligible: state => state.isEligible,
        isLogin: state => state.isLogin,
        continueButton: state => state.continueButton,
        needHelpButton: state => state.needHelpButton,
        showFooter: state => state.showFooter
    },

    actions:{
        loadFeeAgreement({commit,getters},fa){
            commit('updateFeeAgreement',fa)
        },
        setShowFooter({commit,getters}, isShow){
            commit('setShowFooter',isShow)
        },
        setEligibility({commit,getters},eligibility){
            commit('setEligibility',eligibility)
        },
        setNeedHelpButton({commit,getters},needHelpButton) {
            commit('setNeedHelpButton', needHelpButton);
        },
        setContinueButton({commit,getters},continueButton) {
            commit('setContinueButton', continueButton);
        }
    }
}

export default module;
